<div class="m-4 p-2 border border-grey-900 rounded-md bg-grey-100">
  <h3 class="p-2">Add {{ 'audit' | customerTerm }}</h3>
  @if (showAudit) {
    <div class="p-4 pt-6">
      <label class="block">
        <span class="font-bold standardTextSize">{{ 'audit' | customerTerm }}</span>
        <select class="text-box w-full md:max-w-xl mt-2 standardTextSize" [(ngModel)]="selectedAudit" (change)="selectedAuditChanged()">
          @for (audit of audits.Audits; track audit) {
            <option [ngValue]="audit" [disabled]="audit.AuditID == -1">
              {{ audit.AuditName }}
            </option>
          }
        </select>
      </label>
    </div>
  }
  @if (showLocation) {
    <div class="p-4">
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToAudit()">edit</span> {{selectedAudit.AuditName}}</p>
      @if (!topLevel) {
        <div (click)="resetLocations()">
          <span>Reset Locations</span>
        </div>
      }
      @for (l of selectedLocations; track l) {
        <div class="flex w-full my-2">
          <span
            class="p-2 md:p-4 flex-grow standardTextSize bg-standardwhite border-spacing-1.5 border-b-grey-500 border-s-2  flex justify-between align-middle hover:hover-for-select"
            [ngClass]="{'selected': l.Location.LocationID == selectedLocation.Location.LocationID}"
          (click)="selectLocation(l)">{{l.Location.LocationName}}</span>
          @if (l!.SubLocations.length > 0) {
            <div
              class=" bg-standardwhite "
              (click)="chooseSublocation(l)">
              <span class="standardTextSize text-offblack hover:hover-for-select border-grey-900 border-spacing-2 border-s h-full px-4 flex items-center">Sub Locations</span>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (showUsers) {
    <div class="p-4 pt-6">
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToAudit()">edit</span> {{selectedAudit.AuditName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToLocation()">edit</span> {{selectedLocation.Location.LocationName}}</p>
      <label class="block">
        <span class="font-bold standardTextSize">Assigned to</span>
        <select class="text-box w-full md:max-w-xl mt-2 standardTextSize" [(ngModel)]="selectedUser" (change)="selectedAuditorChanged()" >
          @for (user of allUsers; track user) {
            <option [ngValue]="user" [disabled]="user.UserID == -1"
              [ngClass]="{'font-bold':user.UserTypeID==2}">
              {{ user.DisplayName }}
            </option>
          }
        </select>
      </label>
    </div>
  }
  @if (showFrequency) {
    <div class="p-4 pt-6">
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToAudit()">edit</span> {{selectedAudit.AuditName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToLocation()">edit</span> {{selectedLocation.Location.LocationName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToAuditor()">edit</span> {{selectedUser.DisplayName}}</p>
      <span class="font-bold standardTextSize">Frequency</span>
      <select class="text-box w-full md:max-w-xl mt-2 standardTextSize" [(ngModel)]="selectedFrequency" (change)="selectedFrequencyChanged()" >
        @for (freq of allFrequencies; track freq) {
          <option [ngValue]="freq" [disabled]="freq.ID == -1">
            {{ freq.Description }}
          </option>
        }
      </select>
    </div>
  }
  @if (showStart) {
    <div class="p-4 pt-6">
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToAudit()">edit</span> {{selectedAudit.AuditName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToLocation()">edit</span> {{selectedLocation.Location.LocationName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToAuditor()">edit</span> {{selectedUser.DisplayName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToFrequency()">edit</span> {{selectedFrequency.Description}}</p>
      <label>
        <span class="font-bold standardTextSize">Start Date</span>
        <div class="flex gap-2 items-baseline">
          <p-datepicker class="date-input w-1/5" inputStyleClass="text-box" [(ngModel)]="startDate" [minDate]="today" dateFormat="dd M yy" [firstDayOfWeek]="1" [showIcon]="false"></p-datepicker>
          <button class="btn-primary w-auto text-sm h-8 leading-3 p-2" (click)="updateStartDate()">Confirm Start Date</button>
        </div>
      </label>
      @if (showStartDateError) {
        <p class="form-error">The start date is not valid.</p>
      }
    </div>
  }
  @if (showEnd) {
    <div class="p-4 pt-6">
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToAudit()">edit</span> {{selectedAudit.AuditName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToLocation()">edit</span> {{selectedLocation.Location.LocationName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToAuditor()">edit</span> {{selectedUser.DisplayName}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToFrequency()">edit</span> {{selectedFrequency.Description}}</p>
      <p class="pb-2"><span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="backToStartDate()">edit</span> {{startDate.toDateString()}}</p>
      <span class="font-bold standardTextSize">Enter End Date? </span>
      <div class="pb-2">
        <app-toggle-switch [(checked)]="hasEndDate"></app-toggle-switch>
      </div>
      @if (hasEndDate) {
        <label>
          <p-datepicker class="date-input w-1/5" inputStyleClass="text-box" [(ngModel)]="endDate" [minDate]="startDate" (ngModelChange)="updateEndDate()" dateFormat="dd M yy" [firstDayOfWeek]="1" [showIcon]="false"></p-datepicker>
        </label>
      }
      <button class="btn-primary mt-4" (click)="createEvent()">Create Scheduled Event</button>
      @if (showError) {
        <p class="form-error">The dates entered are invalid, please check and try again.</p>
      }
    </div>
  }
</div>

